<template>
  <div class="flex-col-100" id="app" :class="$route.name">
    <div
      v-if="user.id || $route.name == 'login' || $route.name == 'landing' || $route.name == 'system-login'"
      class="page-container flex-col-100"
    >
      <md-app class="flex-col-100" :class="pageClass">
        <md-app-toolbar
          v-if="$route.name != null && $route.name != 'login' && $route.name != 'landing' && $route.name != 'system-login'"
          class="md-primary main-toolbar"
        >
          <div class="md-toolbar-row md-toolbar-section-start">
            <md-button
              @click="onDashboard"
              v-if="$route.name == 'assessment' || $route.name == 'assessment_user'"
              class="md-button"
            >
              <md-icon>keyboard_backspace</md-icon>Back to dashboard
            </md-button>
            <span class="welcome" v-if="$route.name == 'assessments'">Welcome</span>
          </div>
          <div class="md-toolbar-row md-toolbar-section-end">
            <span class="md-title">{{user.firstName}} {{user.lastName}}</span>
            <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
              <md-icon>menu</md-icon>
            </md-button>
          </div>
        </md-app-toolbar>

        <md-app-drawer class="md-right" :md-active.sync="menuVisible">
          <md-toolbar class="md-transparent" md-elevation="0">
            <md-button class="md-icon-button close-btn" @click="menuVisible = !menuVisible">
              <md-icon>close</md-icon>
            </md-button>
          </md-toolbar>
          <md-list v-if="isFaculty()">
            <md-list-item>
              <span class="md-list-item-text">
                <md-button @click="onStart">
                  <md-icon>add_box</md-icon>Start Assessment
                </md-button>
              </span>
            </md-list-item>
            <md-list-item>
              <span class="md-list-item-text">
                <md-button @click="onView">
                  <md-icon>list_alt</md-icon>View Assessment
                </md-button>
              </span>
            </md-list-item>
            <md-list-item>
              <span class="md-list-item-text">
                <md-button @click="onLogout">
                  <md-icon>exit_to_app</md-icon>Log out
                </md-button>
              </span>
            </md-list-item>
          </md-list>
          <md-list v-else>
            <md-list-item>
              <span class="md-list-item-text">
                <md-button @click="onDashboard">
                  <md-icon>list_alt</md-icon>Dashboard
                </md-button>
              </span>
            </md-list-item>
            <md-list-item>
              <span class="md-list-item-text">
                <md-button @click="onLogout">
                  <md-icon>exit_to_app</md-icon>Log out
                </md-button>
              </span>
            </md-list-item>
          </md-list>
        </md-app-drawer>

        <md-app-content class="flex-col-100">
          <keep-alive>
            <router-view
              @create="create = $event"
              :create="create"
              :user="user"
              :isAdmin="isAdmin"
              @update-user="udateUser"
              :redirect="redirect"
            />
          </keep-alive>
        </md-app-content>
      </md-app>
    </div>
    <div class="flex-col-100" v-else>
      <div class="flex-col-100" id="app">
        <div
          v-if="user.id || $route.name == 'login' || $route.name == 'landing' || $route.name == 'system-login'"
          class="page-container flex-col-100"
        >
          <md-app class="flex-col-100 login">
            <md-app-content class="flex-col-100">
              <Splash />
            </md-app-content>
          </md-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ME from "./graphql/Me.gql";
import Splash from "./components/Splash";
import RoleHelper from "./components/RoleMixin";

export default {
  mixins: [RoleHelper],
  created() {
    this.udateUser();
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener('resize', () => {
        setTimeout(() => {
          let height = document.querySelector('.main-toolbar') ? document.querySelector('.main-toolbar').offsetHeight : 0;
          document.querySelector('body').style.paddingTop = height + 'px';
          let buttonHeight = document.querySelector('.action-buttons') ? document.querySelector('.action-buttons').offsetHeight + 20 : null;
          if(document.querySelector('.md-app-content')) {
            document.querySelector('.md-app-content').style.paddingBottom = buttonHeight + 'px';
          }
        }, 200);
      })
      window.dispatchEvent(new Event('resize'));
    }, 500);
    window.addEventListener('relogin',() => {
      alert('Session timeout');
      window.location.href = '/';
    });
    let refreshUser = () => {
      setTimeout(() => {
        refreshUser();
      }, 10000);
      if(!this.user || !this.user.id ) {
        return
      }
      this.$apollo
        .mutate({
          mutation: require('./graphql/RefreshToken.gql'),
          fetchPolicy: "no-cache"
        })
        .then(data => {
          if (data && data.data.refreshToken) {
            window.localStorage.setItem('apollo-token', data.data.refreshToken);
            return;
          }
        })
        .catch(() => {});

    }
    refreshUser();
  },
  components: {
    Splash
  },
  data() {
    return {
      menuVisible: false,
      user: {},
      redirect: null,
      create: false
    };
  },
  computed: {
    isAdmin() {
      return (
        this.user &&
        this.user.roles &&
        this.user.roles.filter(role => {
          return role.label == "admin";
        }).length
      );
    },
    pageClass() {
      let classObj = {};
      classObj[this.$route.name] = true;
      return classObj;
    }
  },
  methods: {
    udateUser() {
      let self = this;
      this.$apollo
        .query({
          query: ME,
          fetchPolicy: "no-cache"
        })
        .then(data => {
          if (!data.error && data.data.me.id) {
            self.user = data.data.me;
            this.$store.commit("setUser", data.data.me);
            return;
          }
          if (
            self.$route.name != "login" &&
            self.$route.name != "system-login"
          ) {
            self.$router.push("/login");
          }
        })
        .catch(() => {
          if (
            self.$route.name != "login" &&
            self.$route.name != "system-login" &&
            !window.location.href.match(/system\/login/)
          ) {
            self.$router.push("/login");
          }
        });
    },
    onLogout() {
      window.localStorage.removeItem("apollo-token");
      window.location.href = "/";
    },
    onStart() {
      if (this.$route.name == "assessments") {
        this.create = true;
        this.menuVisible = false;
        return;
      } else {
        this.$router.push({ path: "/dashboard/assessments#create" });
        this.menuVisible = false;
        this.create = true;
      }
    },
    onView() {
      if (this.$route.name == "assessments") {
        this.menuVisible = false;
        return;
      } else {
        this.$router.push({ path: "/dashboard/assessments" });
        this.menuVisible = false;
      }
    },
    onDashboard() {
      this.redirect = null;
      if (
        this.$route.name == "assessment" ||
        this.$route.name == "assessment_user"
      ) {
        this.redirect = { path: "/dashboard/assessments" };
        this.menuVisible = false;
        return;
      }

      this.$router.push({ path: "/" });
      this.menuVisible = false;
      //window.location.href = "/"
    },
  },
  watch: {
    '$route' () {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 300);
    }
  }
};
</script>

<style lang="scss">
body {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.md-app-scroller {
  flex-direction: column;
  flex: 1;
  display: flex;
}
.flex-col-100 {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.welcome {
  font-size: 18px;
  font-weight: 900;
  line-height: 10px;
  padding-left: 10px;
}
</style>